import React, {useState} from "react";
import ProfilePic from "../img/photo1.jpg";
import {useHistory} from "react-router-dom"

const Header = () => {
    const [nav, setNav] = useState({
        toggled: false
    })

    const history = useHistory();

    const go =  (url) => {
        setTimeout(() => {
            history.push(url)
        }, 1500)
    }

    return(
        <header>
            <nav>
                <div className="menu-btn" onClick={() => setNav({toggled: true})}>
                    <div></div>
                    <div></div>
                    <div></div>
                </div>

                <div className="nav-brand fa fa-briefcase" onClick={() => go("/home")}></div>

                <div className={nav.toggled === false ? "navbar" : "toggled-true navbar"}>
                    <div className="col">
                        <span className="fa fa-times close-btn" onClick={() => setNav({toggled: false})}></span>
                        <div className="nav-links">
                            <li className="fa fa-home" onClick={() => go("/home")}></li>
                            <li className="fa fa-info" onClick={() => go("/about")}></li>
                            <li className="fa fa-cogs" onClick={() => go("/services")}></li>
                            <li className="fa fa-phone" onClick={() => go("/contact")}></li>
                        </div>
                        <div className="bio-data fa fa-user dropdown">
                            <div className="panel">
                                <div className="img">
                                    <img alt="profile-pic" src={ProfilePic}/>
                                </div>
                                <div className="data">
                                    <div className="label">
                                        <i className="fa fa-user"></i>
                                        <p>Akinleye Joshua</p>
                                    </div>
                                    <div className="label">
                                        <i className="fa fa-briefcase"></i>
                                        <p>Software Developer</p>
                                    </div>
                                    <div className="label">
                                        <i className="fa fa-phone"></i>
                                        <p>+234 09025452313</p>
                                    </div>
                                    <div className="label">
                                        <i className="fa fa-envelope"></i>
                                        <p>akinleyejoshua.dev@gmail.com</p>
                                    </div>
                                </div>
                                
                                <div className="social-handles">
                                    <a href="https://www.github.com/Akinleyejoshua" target="_blank" className="fa fa-github" rel="noopener noreferrer"></a>
                                    <a href="https://www.linkedin.com" target="_blank" className="fa fa-linkedin" rel="noopener noreferrer"></a>
                                    <a href="https://www.twitter.com/AkinleyeJoshua9" target="_blank" className="fa fa-twitter" rel="noopener noreferrer"></a>
                                    <a href="https:wa.me/23409025452313" target="_blank" className="fa fa-whatsapp" rel="noopener noreferrer"></a>
                                </div>
                            </div>
                        </div>
                    </div>
                   <div className="close-nav" onClick={() => setNav({toggled: false})}></div>
                </div>
            </nav>
        </header>
    )
};

export default Header;